import { useEffect, useCallback } from "react";

export const useEventListeners = (showContextMenu, setShowContextMenu) => {
  const closeContextMenu = useCallback(() => {
    setShowContextMenu(false);
  }, [setShowContextMenu]);

  // Click outside to close context menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showContextMenu && !event.target.closest(".context-menu")) {
        closeContextMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showContextMenu, closeContextMenu]);

  // Handle drag over
  useEffect(() => {
    const handleDragOver = (event) => {
      event.preventDefault();
    };

    document.body.addEventListener("dragover", handleDragOver);

    return () => {
      document.body.removeEventListener("dragover", handleDragOver);
    };
  }, []);

  return { closeContextMenu };
};
